export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <span className="text-xl font-heading font-bold text-background-50 mb-3 block">宅男视频</span>
              <p className="text-xs text-background-400 leading-relaxed">
                聚合久久视频、小蓝视频、豆花视频等稳定平台，提供不缓冲的流畅高清在线观看体验，每日更新免费影视全集。
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#hero" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">首页</a>
                <a href="#index" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">影视索引</a>
                <a href="#ranking" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">热度榜单</a>
                <a href="#faq" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">常见问题</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">内容平台</h4>
              <div className="flex flex-col gap-2">
                <span className="text-xs text-background-400">久久视频</span>
                <span className="text-xs text-background-400">小蓝视频</span>
                <span className="text-xs text-background-400">豆花视频</span>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
              <p className="text-xs text-background-500">暂无合作伙伴信息</p>
            </div>
          </div>
          <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">宅男视频 © 2026 版权所有 | 流畅高清不缓冲在线观影</p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">服务条款</a>
              <a href="#contact" className="text-xs text-background-400 hover:text-background-100 transition-colors no-underline cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}